import { render, staticRenderFns } from "./Lung.vue?vue&type=template&id=005744ec&"
import script from "./Lung.vue?vue&type=script&lang=ts&"
export * from "./Lung.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports